export default [
  {
    id: "AUT",
    color: 'blueGreyLighten',
    summary: 'Distribución automática de documentos',
    icon: 'mdi-email-arrow-right'
  },
  {
    id: "MAN",
    color: 'blueGreyLighten',
    summary: 'Distribución manual de documentos',
    icon: 'mdi-email'
  },
  {
    id: "VOI",
    color: 'blueGreyLighten',
    summary: 'Notificación de baja de documentos',
    icon: 'mdi-file-remove-outline'
  },
  {
    id: "CSM",
    color: 'blueGreyLighten',
    summary: 'Distribución normativa de documentos',
    icon: 'mdi-file-send-outline'
  },
  {
    id: "REC",
    color: 'blueGreyLighten',
    summary: 'Notificación de acuse de recibo',
    icon: 'mdi-file-check-outline'
  },
  {
    id: "RCO",
    color: 'blueGreyLighten',
    summary: 'Comprobante comercial',
    icon: 'mdi-invoice-list-outline'
  }
]
